import type { RefObject } from 'react';
import type { Control, FieldPath, FieldValues } from 'react-hook-form';
import React from 'react';

import { Controller } from 'react-hook-form';

import { Combobox } from '../Combobox';
import BB from './BB';
import BE from './BE';
import BW from './BW';
import BY from './BY';
import HB from './HB';
import HE from './HE';
import HH from './HH';
import MV from './MV';
import NI from './NI';
import NW from './NW';
import RP from './RP';
import SH from './SH';
import SL from './SL';
import SN from './SN';
import ST from './ST';
import TH from './TH';

export const states = [
  {
    value: 'BW',
    label: 'Baden-Württemberg',
    Component: BW,
  },
  {
    value: 'BY',
    label: 'Bayern',
    Component: BY,
  },
  {
    value: 'BE',
    label: 'Berlin',
    Component: BE,
  },
  {
    value: 'BB',
    label: 'Brandenburg',
    Component: BB,
  },
  {
    value: 'HB',
    label: 'Bremen',
    Component: HB,
  },
  {
    value: 'HH',
    label: 'Hamburg',
    Component: HH,
  },
  {
    value: 'HE',
    label: 'Hessen',
    Component: HE,
  },
  {
    value: 'MV',
    label: 'Mecklenburg-Vorpommern',
    Component: MV,
  },
  {
    value: 'NI',
    label: 'Niedersachsen',
    Component: NI,
  },
  {
    value: 'NW',
    label: 'Nordrhein-Westfalen',
    Component: NW,
  },
  {
    value: 'RP',
    label: 'Rheinland-Pfalz',
    Component: RP,
  },
  {
    value: 'SL',
    label: 'Saarland',
    Component: SL,
  },
  {
    value: 'SN',
    label: 'Sachsen',
    Component: SN,
  },
  {
    value: 'ST',
    label: 'Sachsen-Anhalt',
    Component: ST,
  },
  {
    value: 'SH',
    label: 'Schleswig-Holstein',
    Component: SH,
  },
  {
    value: 'TH',
    label: 'Thüringen',
    Component: TH,
  },
  { value: 'NOT_SPECIFIED', label: ' ' },
];

export const germanStateMap = new Map(states.map((state) => [state.value, state]));

interface StateSelectProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>;
  name: FieldPath<TFieldValues>;
  ref?: RefObject<HTMLDivElement>;
}

export const StateSelect = <TFieldValues extends FieldValues>({
  control,
  name,
}: StateSelectProps<TFieldValues>) => {
  const stateOptions = states.map(({ value, label }) => ({
    value,
    label,
    icon:
      value === 'NOT_SPECIFIED' ? null : (
        <img
          src={`../images/states/${value}.png`}
          alt={label}
          loading="lazy"
          style={{
            maxHeight: '21px',
            maxWidth: '29px',
            objectFit: 'contain',
          }}
        />
      ),
  }));

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <Combobox
          {...field}
          options={stateOptions}
          width="270px"
        />
      )}
    />
  );
};
